/* global Foundation */

import $ from 'jquery';
import each from 'lodash/each';

function setupAccordion(el) {
  new Foundation.Accordion($(el), {
    allowAllClosed: true,
    multiExpand: true,
  });
}

/**
 * Set up accordions in the container.
 *
 * @param {HTMLElement} container
 */
function setupAccordions(container) {
  if (!container) {
    return;
  }

  // Initialize existing elements:
  // No need. Foundation already does it.

  // Observe for new elements:

  const observer = new MutationObserver((mutations) => {
    each(mutations, (mutation) => {
      each(mutation.addedNodes, (node) => {
        if (node.nodeType !== 1) {
          return;
        }

        const els = node.querySelectorAll('[data-accordion]');
        if (!els.length) {
          return;
        }

        each(els, (el) => {
          setupAccordion(el);
        });
      });
    });
  });

  observer.observe(container, {
    childList: true,
    subtree: true,
    attributes: false,
    characterData: false,
  });
}

// eslint-disable-next-line import/prefer-default-export
export { setupAccordions };
